
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebd04"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebd04"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lzAtk", function(module, exports) {

$parcel$export(module.exports, "el", function () { return $fb4928731a218ed9$export$c3da0dad1b44eea9; });
$parcel$export(module.exports, "archiveExt", function () { return $fb4928731a218ed9$export$3022981a61b8b896; });
$parcel$export(module.exports, "hasThumbnail", function () { return $fb4928731a218ed9$export$24ca34d5580b46ef; });
$parcel$export(module.exports, "docUrl", function () { return $fb4928731a218ed9$export$8535ffa4b9c39c0; });
$parcel$export(module.exports, "documentUrl", function () { return $fb4928731a218ed9$export$139465377731b305; });
$parcel$export(module.exports, "fileLabel", function () { return $fb4928731a218ed9$export$561c268552cfa034; });
$parcel$export(module.exports, "thumbUrl", function () { return $fb4928731a218ed9$export$8ba4149c4af32e7a; });
$parcel$export(module.exports, "preview", function () { return $fb4928731a218ed9$export$48c2d0f2f545ac27; });
$parcel$export(module.exports, "formatDate", function () { return $fb4928731a218ed9$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "relativeDay", function () { return $fb4928731a218ed9$export$65d91f53a7fc3ecd; });
$parcel$export(module.exports, "fetchHome", function () { return $fb4928731a218ed9$export$5b6c3184491a2f1a; });
$parcel$export(module.exports, "searchPreview", function () { return $fb4928731a218ed9$export$72c45173595e51d2; });
$parcel$export(module.exports, "TOPICS", function () { return $fb4928731a218ed9$export$59a52cdd0906f4cb; });
$parcel$export(module.exports, "contextualDocumentTitle", function () { return (parcelRequire("93Awn")).contextualDocumentTitle; });
$parcel$export(module.exports, "isTrustedVorgang", function () { return (parcelRequire("93Awn")).isTrustedVorgang; });
$parcel$export(module.exports, "VORGANG_LIMIT", function () { return (parcelRequire("93Awn")).VORGANG_LIMIT; });
// Geteilte Bausteine der Startseiten-Varianten: DOM-Helfer, Formatierung,
// Datenzugriff. Bewusst ohne Layout-Annahmen – jede Variante rendert selbst.

var $93Awn = parcelRequire("93Awn");
const $fb4928731a218ed9$export$c3c2ed07aa099fe7 = "https://hel1.your-objectstorage.com/ratsinfocux";
function $fb4928731a218ed9$export$c3da0dad1b44eea9(tag, props = {}, children = []) {
    const node = document.createElement(tag);
    for (const [k, v] of Object.entries(props)){
        if (v == null || v === false) continue;
        if (k === "class") node.className = v;
        else if (k === "text") node.textContent = v;
        else if (k.startsWith("on") && typeof v === "function") node.addEventListener(k.slice(2).toLowerCase(), v);
        else node.setAttribute(k, v);
    }
    for (const child of Array.isArray(children) ? children : [
        children
    ]){
        if (child == null || child === false) continue;
        node.appendChild(typeof child === "string" ? document.createTextNode(child) : child);
    }
    return node;
}
function $fb4928731a218ed9$export$3022981a61b8b896(doc) {
    const ext = typeof doc.archive_ext === "string" ? doc.archive_ext.trim() : "";
    if (ext) return ext.startsWith(".") ? ext : `.${ext}`;
    return $fb4928731a218ed9$export$b4fc3bacd55be02d(doc) ? ".txt" : ".pdf";
}
function $fb4928731a218ed9$export$b4fc3bacd55be02d(doc) {
    if (typeof doc.archive_ext === "string" && doc.archive_ext.trim()) return doc.archive_ext.trim().toLowerCase().endsWith("txt");
    return typeof doc.link === "string" && doc.link.includes("to020");
}
function $fb4928731a218ed9$export$24ca34d5580b46ef(doc) {
    return $fb4928731a218ed9$export$3022981a61b8b896(doc).toLowerCase() === ".pdf";
}
function $fb4928731a218ed9$export$8535ffa4b9c39c0(doc) {
    return `${$fb4928731a218ed9$export$c3c2ed07aa099fe7}/${doc.hash}${$fb4928731a218ed9$export$3022981a61b8b896(doc)}`;
}
function $fb4928731a218ed9$export$139465377731b305(doc, query = "") {
    const hash = typeof doc === "string" ? doc : doc === null || doc === void 0 ? void 0 : doc.hash;
    const base = `/dokument?hash=${encodeURIComponent(hash !== null && hash !== void 0 ? hash : "")}`;
    // Suchbegriff mitgeben, damit die Detailseite ihn im Dokument hervorhebt.
    return query.trim() ? `${base}&q=${encodeURIComponent(query.trim())}` : base;
}
function $fb4928731a218ed9$export$561c268552cfa034(doc) {
    const ext = $fb4928731a218ed9$export$3022981a61b8b896(doc).replace(/^\./, "").toUpperCase();
    return ext === "TXT" ? "Text" : ext;
}
function $fb4928731a218ed9$export$8ba4149c4af32e7a(doc) {
    return `${$fb4928731a218ed9$export$c3c2ed07aa099fe7}/${doc.hash}.png`;
}
/** Platzhalter, wenn kein Vorschaubild existiert — hält das Raster gleichmäßig. */ function $fb4928731a218ed9$var$previewPlaceholder(doc, cls) {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    for (const [k, v] of Object.entries({
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "1.6",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "aria-hidden": "true"
    }))svg.setAttribute(k, v);
    for (const [tag, attrs] of [
        [
            "path",
            {
                d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
            }
        ],
        [
            "path",
            {
                d: "M14 2v5h6"
            }
        ],
        [
            "path",
            {
                d: "M8 13h8"
            }
        ],
        [
            "path",
            {
                d: "M8 17h5"
            }
        ]
    ]){
        const node = document.createElementNS("http://www.w3.org/2000/svg", tag);
        for (const [k, v] of Object.entries(attrs))node.setAttribute(k, v);
        svg.appendChild(node);
    }
    return $fb4928731a218ed9$export$c3da0dad1b44eea9("div", {
        class: `preview-fallback ${cls}`.trim()
    }, [
        svg,
        $fb4928731a218ed9$export$c3da0dad1b44eea9("span", {
            class: "preview-fallback-label",
            text: doc.dokumenttyp || $fb4928731a218ed9$export$561c268552cfa034(doc)
        })
    ]);
}
function $fb4928731a218ed9$export$48c2d0f2f545ac27(doc, { imgClass: imgClass = "", fallbackClass: fallbackClass = "" } = {}) {
    // Nur PDFs haben überhaupt ein Vorschaubild – Textbeiträge und nicht
    // konvertierte Anhänge (.docx, .xlsx, …) bekommen direkt den Platzhalter.
    if (!$fb4928731a218ed9$export$24ca34d5580b46ef(doc)) return $fb4928731a218ed9$var$previewPlaceholder(doc, fallbackClass);
    const img = $fb4928731a218ed9$export$c3da0dad1b44eea9("img", {
        class: imgClass,
        src: $fb4928731a218ed9$export$8ba4149c4af32e7a(doc),
        alt: "",
        loading: "lazy"
    });
    img.addEventListener("error", ()=>{
        img.replaceWith($fb4928731a218ed9$var$previewPlaceholder(doc, fallbackClass));
    });
    return img;
}
function $fb4928731a218ed9$export$3ae94a2503e890a1(value) {
    if (!value) return "";
    const d = typeof value === "number" ? new Date(value * 1000) : new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });
}
function $fb4928731a218ed9$export$8b492ed8828f789c(value, hasTime = true) {
    if (!value) return "";
    const d = typeof value === "number" ? new Date(value * 1000) : new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    const date = d.toLocaleDateString("de-DE", {
        weekday: "short",
        day: "2-digit",
        month: "short"
    });
    if (!hasTime) return `${date} \xb7 Uhrzeit noch offen`;
    return date + ", " + d.toLocaleTimeString("de-DE", {
        hour: "2-digit",
        minute: "2-digit"
    }) + " Uhr";
}
function $fb4928731a218ed9$export$65d91f53a7fc3ecd(value) {
    if (!value) return "";
    const d = typeof value === "number" ? new Date(value * 1000) : new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    const days = Math.round((d.getTime() - Date.now()) / 86400000);
    if (days === 0) return "heute";
    if (days === 1) return "morgen";
    if (days === -1) return "gestern";
    if (days > 1) return `in ${days} Tagen`;
    return `vor ${Math.abs(days)} Tagen`;
}
async function $fb4928731a218ed9$export$5b6c3184491a2f1a({ documents: documents = 8, meetings: meetings = 5 } = {}) {
    const res = await fetch(`/api/home?documents=${documents}&meetings=${meetings}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
}
async function $fb4928731a218ed9$export$72c45173595e51d2(query, limit = 5) {
    const res = await fetch(`/api/search-preview?q=${encodeURIComponent(query)}&limit=${limit}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
}
const $fb4928731a218ed9$export$59a52cdd0906f4cb = [
    "Radweg",
    "Bebauungsplan",
    "Kita",
    "Haushalt",
    "Windkraft",
    "Feuerwehr",
    "Tourismus",
    "Schule"
];

});
parcelRegister("93Awn", function(module, exports) {

$parcel$export(module.exports, "SEARCH_INDEX", function () { return $a2f42c0949f17531$export$8621c1cb383379a5; });
$parcel$export(module.exports, "isIsoDate", function () { return $a2f42c0949f17531$export$88436b756d94fab0; });
$parcel$export(module.exports, "buildDateFilter", function () { return $a2f42c0949f17531$export$e7cc90e0b4e7ec80; });
$parcel$export(module.exports, "dateRangeFromFilter", function () { return $a2f42c0949f17531$export$ae6f17d001af1b06; });
$parcel$export(module.exports, "searchStateToRoute", function () { return $a2f42c0949f17531$export$f4a42730c368366f; });
$parcel$export(module.exports, "searchRouteToState", function () { return $a2f42c0949f17531$export$ca5416d3a936475; });
$parcel$export(module.exports, "groupSearchHits", function () { return $a2f42c0949f17531$export$b34e83562b871bf3; });
$parcel$export(module.exports, "contextualDocumentTitle", function () { return $a2f42c0949f17531$export$abe621c3ad40f680; });
$parcel$export(module.exports, "VORGANG_LIMIT", function () { return $a2f42c0949f17531$export$f31bf80e162e0322; });
$parcel$export(module.exports, "isTrustedVorgang", function () { return $a2f42c0949f17531$export$53ab8e9c49589242; });
const $a2f42c0949f17531$export$8621c1cb383379a5 = "sitzungspaket";
const $a2f42c0949f17531$var$SORT_TO_ROUTE = {
    [`${$a2f42c0949f17531$export$8621c1cb383379a5}/sort/start:desc`]: "neueste",
    [`${$a2f42c0949f17531$export$8621c1cb383379a5}/sort/start:asc`]: "aelteste"
};
const $a2f42c0949f17531$var$ROUTE_TO_SORT = Object.fromEntries(Object.entries($a2f42c0949f17531$var$SORT_TO_ROUTE).map(([index, route])=>[
        route,
        index
    ]));
function $a2f42c0949f17531$var$firstString(value) {
    if (Array.isArray(value)) return $a2f42c0949f17531$var$firstString(value[0]);
    if (typeof value !== "string") return undefined;
    const trimmed = value.trim();
    return trimmed || undefined;
}
function $a2f42c0949f17531$var$stringList(value) {
    const values = Array.isArray(value) ? value : [
        value
    ];
    return values.flatMap((entry)=>typeof entry === "string" ? entry.split(",") : []).map((entry)=>entry.trim()).filter(Boolean);
}
function $a2f42c0949f17531$export$88436b756d94fab0(value) {
    if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const date = new Date(`${value}T00:00:00Z`);
    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
}
function $a2f42c0949f17531$var$startOfUtcDay(value) {
    return Math.floor(new Date(`${value}T00:00:00Z`).getTime() / 1000);
}
function $a2f42c0949f17531$export$e7cc90e0b4e7ec80(range) {
    const from = $a2f42c0949f17531$export$88436b756d94fab0(range === null || range === void 0 ? void 0 : range.from) ? range.from : undefined;
    const to = $a2f42c0949f17531$export$88436b756d94fab0(range === null || range === void 0 ? void 0 : range.to) ? range.to : undefined;
    if (!from && !to) return undefined;
    const fromTimestamp = from ? $a2f42c0949f17531$var$startOfUtcDay(from) : undefined;
    const toTimestamp = to ? $a2f42c0949f17531$var$startOfUtcDay(to) + 86399 : undefined;
    if (fromTimestamp !== undefined && toTimestamp !== undefined) return `start:[${fromTimestamp}..${toTimestamp}]`;
    return fromTimestamp !== undefined ? `start:>=${fromTimestamp}` : `start:<=${toTimestamp}`;
}
function $a2f42c0949f17531$var$isoDateFromTimestamp(timestamp) {
    if (!Number.isFinite(timestamp)) return undefined;
    return new Date(timestamp * 1000).toISOString().slice(0, 10);
}
function $a2f42c0949f17531$export$ae6f17d001af1b06(filter) {
    if (typeof filter !== "string") return undefined;
    const between = filter.match(/^start:\[(\d+)\.\.(\d+)\]$/);
    if (between) return {
        from: $a2f42c0949f17531$var$isoDateFromTimestamp(Number(between[1])),
        to: $a2f42c0949f17531$var$isoDateFromTimestamp(Number(between[2]) - 86399)
    };
    const from = filter.match(/^start:>=(\d+)$/);
    if (from) return {
        from: $a2f42c0949f17531$var$isoDateFromTimestamp(Number(from[1]))
    };
    const to = filter.match(/^start:<=(\d+)$/);
    if (to) return {
        to: $a2f42c0949f17531$var$isoDateFromTimestamp(Number(to[1]) - 86399)
    };
    return undefined;
}
function $a2f42c0949f17531$var$addList(target, attribute, value) {
    const values = $a2f42c0949f17531$var$stringList(value);
    if (values.length) target[attribute] = values;
}
function $a2f42c0949f17531$export$f4a42730c368366f(uiState) {
    var _state_query, _state_refinementList_Kommune, _state_refinementList, _state_refinementList_Gremium, _state_refinementList1, _state_refinementList_themengruppe, _state_refinementList2, _state_dateRange, _state_dateRange1;
    var _uiState_SEARCH_INDEX;
    const state = (_uiState_SEARCH_INDEX = uiState[$a2f42c0949f17531$export$8621c1cb383379a5]) !== null && _uiState_SEARCH_INDEX !== void 0 ? _uiState_SEARCH_INDEX : {};
    const route = {};
    if ((_state_query = state.query) === null || _state_query === void 0 ? void 0 : _state_query.trim()) route.q = state.query.trim();
    if ((_state_refinementList = state.refinementList) === null || _state_refinementList === void 0 ? void 0 : (_state_refinementList_Kommune = _state_refinementList.Kommune) === null || _state_refinementList_Kommune === void 0 ? void 0 : _state_refinementList_Kommune.length) route.kommune = state.refinementList.Kommune;
    if ((_state_refinementList1 = state.refinementList) === null || _state_refinementList1 === void 0 ? void 0 : (_state_refinementList_Gremium = _state_refinementList1.Gremium) === null || _state_refinementList_Gremium === void 0 ? void 0 : _state_refinementList_Gremium.length) route.gremium = state.refinementList.Gremium;
    if ((_state_refinementList2 = state.refinementList) === null || _state_refinementList2 === void 0 ? void 0 : (_state_refinementList_themengruppe = _state_refinementList2.themengruppe) === null || _state_refinementList_themengruppe === void 0 ? void 0 : _state_refinementList_themengruppe.length) route.thema = state.refinementList.themengruppe;
    const sort = state.sortBy ? $a2f42c0949f17531$var$SORT_TO_ROUTE[state.sortBy] : undefined;
    if (sort) route.sort = sort;
    if (state.page && state.page > 1) route.seite = state.page;
    if ($a2f42c0949f17531$export$88436b756d94fab0((_state_dateRange = state.dateRange) === null || _state_dateRange === void 0 ? void 0 : _state_dateRange.from)) route.von = state.dateRange.from;
    if ($a2f42c0949f17531$export$88436b756d94fab0((_state_dateRange1 = state.dateRange) === null || _state_dateRange1 === void 0 ? void 0 : _state_dateRange1.to)) route.bis = state.dateRange.to;
    if (state.searchMode === "ask") route.modus = "frage";
    return route;
}
function $a2f42c0949f17531$export$ca5416d3a936475(route) {
    const state = {};
    var _route_q;
    const query = $a2f42c0949f17531$var$firstString((_route_q = route.q) !== null && _route_q !== void 0 ? _route_q : route.query);
    if (query) state.query = query;
    const refinementList = {};
    var _route_kommune;
    $a2f42c0949f17531$var$addList(refinementList, "Kommune", (_route_kommune = route.kommune) !== null && _route_kommune !== void 0 ? _route_kommune : route.Kommune);
    var _route_gremium;
    $a2f42c0949f17531$var$addList(refinementList, "Gremium", (_route_gremium = route.gremium) !== null && _route_gremium !== void 0 ? _route_gremium : route.Gremium);
    var _route_thema;
    $a2f42c0949f17531$var$addList(refinementList, "themengruppe", (_route_thema = route.thema) !== null && _route_thema !== void 0 ? _route_thema : route.themengruppe);
    if (Object.keys(refinementList).length) state.refinementList = refinementList;
    const sort = $a2f42c0949f17531$var$firstString(route.sort);
    if (sort && $a2f42c0949f17531$var$ROUTE_TO_SORT[sort]) state.sortBy = $a2f42c0949f17531$var$ROUTE_TO_SORT[sort];
    const rawPage = Array.isArray(route.seite) ? route.seite[0] : route.seite;
    const page = typeof rawPage === "number" ? rawPage : Number($a2f42c0949f17531$var$firstString(rawPage));
    if (Number.isInteger(page) && page > 1) state.page = page;
    const from = $a2f42c0949f17531$var$firstString(route.von);
    const to = $a2f42c0949f17531$var$firstString(route.bis);
    if ($a2f42c0949f17531$export$88436b756d94fab0(from) || $a2f42c0949f17531$export$88436b756d94fab0(to)) state.dateRange = {
        ...$a2f42c0949f17531$export$88436b756d94fab0(from) ? {
            from: from
        } : {},
        ...$a2f42c0949f17531$export$88436b756d94fab0(to) ? {
            to: to
        } : {}
    };
    var _firstString;
    if ([
        "frage",
        "ask"
    ].includes((_firstString = $a2f42c0949f17531$var$firstString(route.modus)) !== null && _firstString !== void 0 ? _firstString : "")) state.searchMode = "ask";
    return {
        [$a2f42c0949f17531$export$8621c1cb383379a5]: state
    };
}
function $a2f42c0949f17531$var$hitContext(item) {
    return {
        kommune: item.Kommune || "",
        gremium: item.Gremium || "",
        start: typeof item.start === "number" ? item.start : null,
        meetingId: item.meeting_id || ""
    };
}
function $a2f42c0949f17531$export$b34e83562b871bf3(items, indexWide) {
    if (indexWide) return items.map((item)=>({
            ...item,
            _duplicateCount: Math.max(1, Number(item._group_found) || 1),
            _duplicateScope: "index",
            _duplicateContexts: [
                $a2f42c0949f17531$var$hitContext(item)
            ]
        }));
    const grouped = new Map();
    items.forEach((item, index)=>{
        const key = item.hash || `id:${item.objectID || item.id || index}`;
        const context = $a2f42c0949f17531$var$hitContext(item);
        const existing = grouped.get(key);
        if (!existing) {
            grouped.set(key, {
                ...item,
                _duplicateCount: 1,
                _duplicateScope: "page",
                _duplicateContexts: [
                    context
                ]
            });
            return;
        }
        existing._duplicateCount += 1;
        if (!existing._duplicateContexts.some((candidate)=>JSON.stringify(candidate) === JSON.stringify(context))) existing._duplicateContexts.push(context);
    });
    return Array.from(grouped.values());
}
function $a2f42c0949f17531$var$formatNumericDate(value) {
    const date = typeof value === "number" ? new Date(value * 1000) : new Date(String(value));
    if (Number.isNaN(date.getTime())) return "";
    return [
        String(date.getUTCDate()).padStart(2, "0"),
        String(date.getUTCMonth() + 1).padStart(2, "0"),
        date.getUTCFullYear()
    ].join(".");
}
const $a2f42c0949f17531$var$GENERIC_TITLE = /^(?:anlage(?:[\s_-]*\d+[a-z]?)?|anhang(?:[\s_-]*\d+[a-z]?)?|begründung|antrag|bekanntmachung|öffentliche bekanntmachung|beschluss(?:vorlage)?|dokument|einladung|mitteilung(?:svorlage)?|niederschrift|protokoll|sitzungsvorlage|tagesordnung|vorlage)$/i;
function $a2f42c0949f17531$export$abe621c3ad40f680(doc) {
    var _doc_title;
    const rawTitle = typeof doc.title === "string" ? doc.title : (_doc_title = doc.title) === null || _doc_title === void 0 ? void 0 : _doc_title.value;
    const title = (rawTitle === null || rawTitle === void 0 ? void 0 : rawTitle.replace(/\s+/g, " ").trim()) || "Dokument";
    if (!$a2f42c0949f17531$var$GENERIC_TITLE.test(title)) return title;
    const context = (doc.Gremium || doc.Kommune || "").trim();
    const date = doc.start ? $a2f42c0949f17531$var$formatNumericDate(doc.start) : "";
    const details = [
        context,
        date
    ].filter(Boolean).join(" \xb7 ");
    return details ? `${title} \u{2013} ${details}` : title;
}
const $a2f42c0949f17531$export$f31bf80e162e0322 = 50;
/** Mehr Gremien hat eine echte, über den Betreff gefundene Beratungsfolge nicht. */ const $a2f42c0949f17531$var$MAX_BETREFF_GREMIEN = 4;
function $a2f42c0949f17531$export$53ab8e9c49589242(vorgangId, title, docs) {
    if (typeof vorgangId !== "string" || !vorgangId) return false;
    if (!vorgangId.startsWith("be:")) return true;
    const rawTitle = typeof title === "string" ? title : title === null || title === void 0 ? void 0 : title.value;
    const normalized = (rawTitle === null || rawTitle === void 0 ? void 0 : rawTitle.replace(/\s+/g, " ").trim()) || "";
    if (!normalized || $a2f42c0949f17531$var$GENERIC_TITLE.test(normalized)) return false;
    if (!docs) return true;
    const gremien = new Set(docs.map((d)=>d.Gremium).filter(Boolean));
    return gremien.size <= $a2f42c0949f17531$var$MAX_BETREFF_GREMIEN;
}

});


// Startseite im Gezeiten-Design: Live-Suchvorschau, Gezeitenkurve der
// kommenden Sitzungen, Abfahrtstafel, neueste Dokumente und Abdeckung.
// Vollständig DOM-basiert, kein innerHTML.
parcelRequire("lzAtk");
var $93Awn = parcelRequire("93Awn");
var $lzAtk = parcelRequire("lzAtk");
const $1f49ea5327d3b666$var$SVG_NS = "http://www.w3.org/2000/svg";
// ── Live-Suchvorschau ───────────────────────────────────────────────
const $1f49ea5327d3b666$var$input = document.getElementById("hero-search-input");
const $1f49ea5327d3b666$var$previewBox = document.getElementById("hero-preview");
let $1f49ea5327d3b666$var$debounceTimer = null;
function $1f49ea5327d3b666$var$renderSearchPreview(query, data) {
    if (!$1f49ea5327d3b666$var$previewBox) return;
    if (!data.hits.length) {
        $1f49ea5327d3b666$var$previewBox.replaceChildren((0, $lzAtk.el)("p", {
            class: "hero-preview-empty",
            text: `Keine Treffer f\xfcr \u{201E}${query}\u{201C}.`
        }));
        $1f49ea5327d3b666$var$previewBox.hidden = false;
        return;
    }
    $1f49ea5327d3b666$var$previewBox.replaceChildren((0, $lzAtk.el)("ul", {
        class: "hero-preview-list"
    }, data.hits.map((hit)=>(0, $lzAtk.el)("li", {}, [
            (0, $lzAtk.el)("a", {
                class: "hero-preview-item",
                href: (0, $lzAtk.documentUrl)(hit, query)
            }, [
                (0, $lzAtk.el)("span", {
                    class: "hero-preview-media"
                }, [
                    (0, $lzAtk.preview)(hit, {
                        imgClass: "hero-preview-thumb",
                        fallbackClass: "hero-preview-fallback"
                    })
                ]),
                (0, $lzAtk.el)("span", {
                    class: "hero-preview-body"
                }, [
                    (0, $lzAtk.el)("span", {
                        class: "hero-preview-title",
                        text: (0, $93Awn.contextualDocumentTitle)(hit)
                    }),
                    (0, $lzAtk.el)("span", {
                        class: "hero-preview-meta",
                        text: [
                            hit.Gremium,
                            hit.Kommune,
                            (0, $lzAtk.formatDate)(hit.start),
                            (0, $lzAtk.fileLabel)(hit)
                        ].filter(Boolean).join(" \xb7 ")
                    }),
                    // KI-Zusammenfassung nur zeigen, wenn vorhanden.
                    hit.summary && (0, $lzAtk.el)("span", {
                        class: "hero-preview-summary",
                        text: hit.summary
                    })
                ])
            ])
        ]))), (0, $lzAtk.el)("a", {
        class: "hero-preview-all",
        href: `/suche?q=${encodeURIComponent(query)}`,
        text: `Alle ${data.found.toLocaleString("de-DE")} Treffer anzeigen`
    }));
    $1f49ea5327d3b666$var$previewBox.hidden = false;
}
function $1f49ea5327d3b666$var$handleSearchInput() {
    if (!$1f49ea5327d3b666$var$input || !$1f49ea5327d3b666$var$previewBox) return;
    const query = $1f49ea5327d3b666$var$input.value.trim();
    clearTimeout($1f49ea5327d3b666$var$debounceTimer);
    if (query.length < 2) {
        $1f49ea5327d3b666$var$previewBox.hidden = true;
        return;
    }
    $1f49ea5327d3b666$var$debounceTimer = setTimeout(async ()=>{
        try {
            const data = await (0, $lzAtk.searchPreview)(query, 5);
            // Nutzer hat weitergetippt -> veraltetes Ergebnis verwerfen.
            if ($1f49ea5327d3b666$var$input.value.trim() !== query) return;
            $1f49ea5327d3b666$var$renderSearchPreview(query, data);
        } catch  {
            $1f49ea5327d3b666$var$previewBox.hidden = true;
        }
    }, 220);
}
function $1f49ea5327d3b666$var$setupSearch() {
    if (!$1f49ea5327d3b666$var$input || !$1f49ea5327d3b666$var$previewBox) return;
    $1f49ea5327d3b666$var$input.addEventListener("input", $1f49ea5327d3b666$var$handleSearchInput);
    $1f49ea5327d3b666$var$input.addEventListener("focus", $1f49ea5327d3b666$var$handleSearchInput);
    document.addEventListener("click", (e)=>{
        if ($1f49ea5327d3b666$var$previewBox.hidden) return;
        if (!e.target.closest(".hero-searchbox")) $1f49ea5327d3b666$var$previewBox.hidden = true;
    });
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") $1f49ea5327d3b666$var$previewBox.hidden = true;
    });
}
function $1f49ea5327d3b666$var$renderTopics() {
    const host = document.getElementById("hero-topics");
    if (!host || !$1f49ea5327d3b666$var$input) return;
    host.replaceChildren(...(0, $lzAtk.TOPICS).slice(0, 6).map((topic)=>(0, $lzAtk.el)("button", {
            class: "hero-chip",
            type: "button",
            text: topic,
            onclick: ()=>{
                $1f49ea5327d3b666$var$input.value = topic;
                $1f49ea5327d3b666$var$input.focus();
                $1f49ea5327d3b666$var$handleSearchInput();
            }
        })));
}
// ── Gezeitenkurve: Sitzungen pro Tag, nächste 14 Tage ────────────────
const $1f49ea5327d3b666$var$TIDE_W = 560;
const $1f49ea5327d3b666$var$TIDE_H = 220;
const $1f49ea5327d3b666$var$TIDE_BASE = 180; // y der Grundlinie
const $1f49ea5327d3b666$var$TIDE_TOP = 40; // y des höchsten Tages
function $1f49ea5327d3b666$var$svgEl(tag, attrs = {}, text = "") {
    const node = document.createElementNS($1f49ea5327d3b666$var$SVG_NS, tag);
    for (const [k, v] of Object.entries(attrs))node.setAttribute(k, v);
    if (text) node.textContent = text;
    return node;
}
/** Weicher Kurvenzug durch die Punkte (waagrechte Tangenten an jedem Punkt). */ function $1f49ea5327d3b666$var$tidePath(points) {
    const [first, ...rest] = points;
    let d = `M${first.x} ${$1f49ea5327d3b666$var$TIDE_BASE} L${first.x} ${first.y}`;
    let prev = first;
    for (const p of rest){
        const mid = (prev.x + p.x) / 2;
        d += ` C${mid} ${prev.y} ${mid} ${p.y} ${p.x} ${p.y}`;
        prev = p;
    }
    return `${d} L${prev.x} ${$1f49ea5327d3b666$var$TIDE_BASE} Z`;
}
function $1f49ea5327d3b666$var$weekdayShort(day) {
    return new Date(`${day}T12:00:00Z`).toLocaleDateString("de-DE", {
        weekday: "short",
        timeZone: "UTC"
    }).replace(".", "");
}
function $1f49ea5327d3b666$var$dayLabel(day) {
    return new Date(`${day}T12:00:00Z`).toLocaleDateString("de-DE", {
        weekday: "long",
        day: "numeric",
        month: "long",
        timeZone: "UTC"
    });
}
function $1f49ea5327d3b666$var$renderTide(perDay) {
    const fig = document.getElementById("tide");
    const host = document.getElementById("tide-chart");
    if (!fig || !host || !Array.isArray(perDay) || perDay.length < 2) return;
    const total = perDay.reduce((sum, d)=>sum + d.count, 0);
    const max = Math.max(1, ...perDay.map((d)=>d.count));
    const step = ($1f49ea5327d3b666$var$TIDE_W - 40) / (perDay.length - 1);
    const points = perDay.map((d, i)=>({
            ...d,
            x: 20 + i * step,
            y: $1f49ea5327d3b666$var$TIDE_BASE - d.count / max * ($1f49ea5327d3b666$var$TIDE_BASE - $1f49ea5327d3b666$var$TIDE_TOP)
        }));
    // Für Screenreader: die Tage mit den meisten Sitzungen in Worten.
    const peaks = points.filter((p)=>p.count === max && p.count > 0).map((p)=>$1f49ea5327d3b666$var$dayLabel(p.day));
    const label = total === 0 ? "In den n\xe4chsten 14 Tagen ist keine Sitzung bekannt." : `${total} Sitzungen in den n\xe4chsten 14 Tagen. Am meisten am ${peaks.join(" und am ")} mit je ${max}.`;
    const svg = $1f49ea5327d3b666$var$svgEl("svg", {
        viewBox: `0 0 ${$1f49ea5327d3b666$var$TIDE_W} ${$1f49ea5327d3b666$var$TIDE_H}`,
        role: "img",
        "aria-label": label,
        class: "tide-svg"
    });
    svg.append($1f49ea5327d3b666$var$svgEl("line", {
        class: "tide-ruler",
        x1: 0,
        y1: $1f49ea5327d3b666$var$TIDE_BASE,
        x2: $1f49ea5327d3b666$var$TIDE_W,
        y2: $1f49ea5327d3b666$var$TIDE_BASE
    }), $1f49ea5327d3b666$var$svgEl("path", {
        class: "tide-water",
        d: $1f49ea5327d3b666$var$tidePath(points)
    }));
    const counts = $1f49ea5327d3b666$var$svgEl("g", {
        class: "tide-count",
        "aria-hidden": "true"
    });
    const days = $1f49ea5327d3b666$var$svgEl("g", {
        class: "tide-day",
        "aria-hidden": "true"
    });
    for (const p of points){
        // Zahl nur dort, wo die Wassersäule hoch genug für die Ziffer ist.
        if (p.count > 0 && $1f49ea5327d3b666$var$TIDE_BASE - p.y >= 30) counts.append($1f49ea5327d3b666$var$svgEl("text", {
            x: p.x,
            y: p.y + 22
        }, String(p.count)));
        days.append($1f49ea5327d3b666$var$svgEl("text", {
            x: p.x,
            y: $1f49ea5327d3b666$var$TIDE_BASE + 22
        }, $1f49ea5327d3b666$var$weekdayShort(p.day)));
    }
    const today = $1f49ea5327d3b666$var$svgEl("g", {
        class: "tide-today",
        "aria-hidden": "true"
    });
    today.append($1f49ea5327d3b666$var$svgEl("line", {
        x1: 20,
        y1: 20,
        x2: 20,
        y2: $1f49ea5327d3b666$var$TIDE_BASE
    }), $1f49ea5327d3b666$var$svgEl("text", {
        x: 28,
        y: 30
    }, "Heute"));
    svg.append(counts, days, today);
    host.replaceChildren(svg);
    const totalNode = document.getElementById("tide-total");
    if (totalNode) totalNode.textContent = total === 1 ? "1 Termin" : `${total.toLocaleString("de-DE")} Termine`;
    fig.hidden = false;
}
// ── Abfahrtstafel: die nächsten Sitzungen ───────────────────────────
function $1f49ea5327d3b666$var$hasReliableTime(ev) {
    const start = ev.start ? new Date(ev.start) : null;
    return ev.has_time === 1 || ev.has_time !== 0 && start && (start.getHours() !== 0 || start.getMinutes() !== 0);
}
function $1f49ea5327d3b666$var$boardRow(ev) {
    const start = ev.start ? new Date(ev.start) : null;
    const href = `/sitzung?id=${encodeURIComponent(ev.external_id)}`;
    const rel = (0, $lzAtk.relativeDay)(ev.start);
    const day = start ? start.toLocaleDateString("de-DE", {
        weekday: "short",
        day: "2-digit",
        month: "2-digit"
    }) : "";
    const time = start && $1f49ea5327d3b666$var$hasReliableTime(ev) ? start.toLocaleTimeString("de-DE", {
        hour: "2-digit",
        minute: "2-digit"
    }) : "offen";
    const title = ev.title || ev.gremium || "Sitzung";
    const sub = [
        ev.gremium !== title ? ev.gremium : null,
        ev.kommune
    ].filter(Boolean).join(", ");
    const docs = ev.attachmentCount || 0;
    return (0, $lzAtk.el)("tr", {}, [
        (0, $lzAtk.el)("td", {
            class: "board-time"
        }, [
            (0, $lzAtk.el)("span", {
                class: "board-clock",
                text: time
            }),
            (0, $lzAtk.el)("span", {
                class: "board-day",
                text: rel === "heute" || rel === "morgen" ? `${rel}, ${day}` : day
            })
        ]),
        (0, $lzAtk.el)("td", {
            class: "board-gremium"
        }, [
            (0, $lzAtk.el)("a", {
                href: href,
                text: title
            }),
            sub && (0, $lzAtk.el)("span", {
                text: sub
            })
        ]),
        (0, $lzAtk.el)("td", {
            class: "board-where",
            text: ev.location || ""
        }),
        (0, $lzAtk.el)("td", {
            class: "board-state"
        }, [
            (0, $lzAtk.el)("span", {
                class: docs > 0 ? "board-pill board-pill--ready" : "board-pill",
                text: docs > 0 ? `${docs} ${docs === 1 ? "Unterlage" : "Unterlagen"}` : "nur Termin"
            })
        ])
    ]);
}
function $1f49ea5327d3b666$var$renderBoard(meetings) {
    const host = document.getElementById("upcoming-meetings");
    if (!host) return;
    if (!meetings.length) {
        host.replaceChildren((0, $lzAtk.el)("p", {
            class: "board-empty",
            text: "Gerade ist keine Sitzung angesetzt. Im Kalender findest du vergangene Sitzungen."
        }));
        return;
    }
    host.replaceChildren((0, $lzAtk.el)("table", {
        class: "board-table"
    }, [
        (0, $lzAtk.el)("thead", {}, [
            (0, $lzAtk.el)("tr", {}, [
                (0, $lzAtk.el)("th", {
                    scope: "col",
                    text: "Wann"
                }),
                (0, $lzAtk.el)("th", {
                    scope: "col",
                    text: "Gremium"
                }),
                (0, $lzAtk.el)("th", {
                    scope: "col",
                    class: "board-where",
                    text: "Ort"
                }),
                (0, $lzAtk.el)("th", {
                    scope: "col",
                    class: "board-state",
                    text: "Unterlagen"
                })
            ])
        ]),
        (0, $lzAtk.el)("tbody", {}, meetings.map($1f49ea5327d3b666$var$boardRow))
    ]));
}
// ── Neu eingegangen ─────────────────────────────────────────────────
function $1f49ea5327d3b666$var$renderDocuments(documents) {
    const host = document.getElementById("latest-documents");
    if (!host) return;
    if (!documents.length) {
        host.replaceChildren((0, $lzAtk.el)("p", {
            class: "home-empty",
            text: "Hier ist gerade nichts Neues."
        }));
        return;
    }
    host.replaceChildren((0, $lzAtk.el)("ul", {
        class: "doc-list"
    }, documents.map((doc)=>(0, $lzAtk.el)("li", {}, [
            (0, $lzAtk.el)("a", {
                href: (0, $lzAtk.documentUrl)(doc),
                text: (0, $93Awn.contextualDocumentTitle)(doc)
            }),
            (0, $lzAtk.el)("p", {
                text: [
                    doc.dokumenttyp || (0, $lzAtk.fileLabel)(doc),
                    doc.Gremium,
                    doc.Kommune,
                    (0, $lzAtk.formatDate)(doc.start)
                ].filter(Boolean).join(", ")
            })
        ]))));
}
// ── Abdeckung: ein Kästchen je Kommune ──────────────────────────────
function $1f49ea5327d3b666$var$renderCoverage(stats) {
    const host = document.getElementById("coverage-meter");
    const { kommunen: kommunen, sources: sources } = stats;
    if (!host || typeof kommunen !== "number" || typeof sources !== "number" || sources < 1) return;
    const withDocs = Math.min(kommunen, sources);
    const without = sources - withDocs;
    const boxes = (0, $lzAtk.el)("div", {
        class: "coverage-boxes",
        role: "img",
        "aria-label": `${withDocs} von ${sources} Kommunen mit Dokumenten`,
        style: `--n: ${sources}`
    });
    for(let i = 0; i < sources; i += 1)boxes.append((0, $lzAtk.el)("i", {
        class: i < withDocs ? "is-full" : ""
    }));
    host.replaceChildren(boxes, (0, $lzAtk.el)("p", {
        class: "coverage-legend"
    }, [
        (0, $lzAtk.el)("span", {
            class: "coverage-key coverage-key--full"
        }),
        `${withDocs} mit Dokumenten`,
        (0, $lzAtk.el)("span", {
            class: "coverage-key"
        }),
        `${without} nur mit Terminen oder ohne Daten`
    ]));
    host.hidden = false;
}
async function $1f49ea5327d3b666$var$loadOverviews() {
    try {
        const data = await (0, $lzAtk.fetchHome)({
            documents: 6,
            meetings: 6
        });
        $1f49ea5327d3b666$var$renderTide(data.meetingsPerDay);
        $1f49ea5327d3b666$var$renderBoard(data.meetings || []);
        $1f49ea5327d3b666$var$renderDocuments(data.documents || []);
        $1f49ea5327d3b666$var$renderCoverage(data.stats || {});
    } catch (err) {
        const host = document.getElementById("upcoming-meetings");
        if (host) host.replaceChildren((0, $lzAtk.el)("p", {
            class: "board-empty",
            text: `Inhalte konnten nicht geladen werden: ${err.message}`
        }));
    }
}
$1f49ea5327d3b666$var$setupSearch();
$1f49ea5327d3b666$var$renderTopics();
$1f49ea5327d3b666$var$loadOverviews();


//# sourceMappingURL=app.f7e4770a.js.map
